import { v4 as uuidv4 } from "uuid";

export function getUUID() {
	return uuidv4();
}

export function getClampUUID(length: number) {
	const uuid = getUUID();
	return uuid.slice(0, length);
}
